import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useIsDesktop } from '../../../utils/mediaQueries';
import { useSidebarContext, useLevelContext } from '../../contexts/Sidebar';
import { StyledMenuItem, StyledMenuButton, StyledMenuLabel, StyledMenuItemDivider, } from './Sidebar.styles';
import styles from './styles';
const { StyledBadge } = styles;
const MenuItem = React.forwardRef(({ notificationCount, children, icon, active, href, as, onClick, toggleOpenMenuState, dividerPosition, ...restProps }, ref) => {
    const level = useLevelContext();
    const { broken, updateSidebarState } = useSidebarContext();
    const isDesktop = useIsDesktop();
    const Component = as || (href ? 'a' : 'button');
    const gaNavAttributes = {
        'data-click-text': children?.toString(),
        'data-type': 'Link',
    };
    const handleClick = (event) => {
        onClick?.(event);
        updateSidebarState({ toggled: false });
        if (toggleOpenMenuState)
            toggleOpenMenuState(false);
    };
    const shouldBreakSpaces = children?.toString() && children?.toString().length > 16;
    const isSelected = href === window.location.pathname;
    const menuContent = notificationCount ? (_jsxs(_Fragment, { children: [_jsx(StyledBadge, { badgeContent: '1', max: 999, children: icon }), _jsx(StyledMenuLabel, { broken: broken, level: level, shouldBreakSpaces: !!shouldBreakSpaces, isDesktop: isDesktop, children: children })] })) : (_jsxs(_Fragment, { children: [icon, _jsx(StyledMenuLabel, { broken: broken, level: level, shouldBreakSpaces: !!shouldBreakSpaces, isDesktop: isDesktop, children: children })] }));
    return (_jsxs(_Fragment, { children: [dividerPosition === 'top' && _jsx(StyledMenuItemDivider, {}), _jsx(StyledMenuItem, { isSelected: isSelected, children: _jsx(StyledMenuButton, { ref: ref, "data-active": active, "data-level": level, level: level, broken: broken, onClick: handleClick, as: Component, href: href, ...restProps, ...gaNavAttributes, children: menuContent }) }), dividerPosition === 'bottom' && _jsx(StyledMenuItemDivider, {})] }));
});
MenuItem.displayName = 'MenuItem';
export default MenuItem;
